module.exports = __webpack_public_path__ + "img/regdown.61f15463.png";